<!-- flex box parent -->
<ng-container *ngIf="globalActions$ | async as globalActions">
  <div
    *ngIf="globalActions.length > 0"
    class="action-wrapper"
    [style]="{ 'flex-flow': orientation === 'vertical' ? 'column wrap' : 'row wrap' }"
  >
    <ng-container *ngFor="let action of globalActions">
      <p-button
        type="button"
        [jmlVar]="{ inProgress: false }"
        #actionButton="jmlVar"
        [icon]="action.icon"
        [class]="[orientation === 'vertical' ? 'action-button-vertical' : 'action-button']"
        [disabled]="actionButton.inProgress"
        [label]="action.tooltip"
        (click)="performAction(action.hrid, actionButton)"
      >
      </p-button>
    </ng-container>
  </div>
</ng-container>
